import React from 'react'
import { makeStyles } from '@material-ui/core'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button'

const useStyles = makeStyles(() => ({
  deleteModalBtn: {
    backgroundColor: '#ffffff',
    width: '25%',
    height: '37px',
    borderRadius: '20px',
    color: '#000',
    textAlign: 'center',
    border: '2px solid #f9b233',

    fontWeight: '600',
    '&:hover': {
      backgroundColor: '#f9b233',
      boxShadow: '0 2px 6px 0 rgba(197, 0, 0, 0.36)',
      color: '#ffffff',
    },
  },
  cancelModalBtn: {
    backgroundColor: '#ffffff',
    width: '25%',
    height: '37px',
    borderRadius: '20px',
    color: '#000',
    textAlign: 'center',
    border: '2px solid #e6332a',
    fontWeight: '600',
    '&:hover': {
      backgroundColor: '#e6332a',
      boxShadow: '0 2px 6px 0 rgba(197, 0, 0, 0.36)',
      color: '#ffffff',
    },
  },
  deleteDialog: {
    '& .MuiDialog-paperWidthSm': {
      width: '50%',
      borderRadius: '20px',
      padding: '0 0 11px',
      backgroundColor: '#fff',
      margin: '22px 94.6px 36px 110.5px',
    },
    '& .MuiBackdrop-root': {
      opacity: '0.6 !important',
      backgroundColor: '#363853',
    },
  },
  dialogHeader: {
    width: '100%',
    height: '53px',
    backgroundImage: 'linear-gradient(#f5aca8, #eb5c55)',
    color: '#ffffff',
    '& .MuiTypography-h6': {
      fontWeight: '600',
      fontSize: '17px',
      '@media (max-width: 960px)': {
        fontSize: '15px',
      },
    },
  },
  dialogDesc: {
    fontWeight: '600',
    fontSize: '17px',
    marginTop: '10px',
    color: '#363853',
    '@media (max-width: 960px)': {
      fontSize: '14px',
    },
  },
  dialogButtons: {
    marginRight: '20px',
  },
}))

export default function SubmitModal({ open, onClose, onSubmit }) {
  const classes = useStyles()

  const handleSubmit = () => {
    onSubmit()
    onClose()
  }

  return (
    <Dialog
      open={open}
      className={classes.deleteDialog}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle className={classes.dialogHeader} id="alert-dialog-title">آیا از ارسال پاسخ اطمینان دارید؟</DialogTitle>
      <DialogContent>
        <DialogContentText className={classes.dialogDesc} id="alert-dialog-description">
          در صورت اطمینان از پاسخ های ثبت شده، آن را برای
          ما ارسال کنید و در انتظار نتیجه آزمون بمانید
        </DialogContentText>
      </DialogContent>
      <DialogActions className={classes.dialogButtons}>
        <Button onClick={onClose} className={classes.cancelModalBtn}>
          لغو
        </Button>
        <Button onClick={handleSubmit} className={classes.deleteModalBtn} autoFocus>
          ارسال
        </Button>
      </DialogActions>
    </Dialog>
  )
}
